import { FunctionComponent } from 'preact';
import { Image } from '../types';
import capitalize from 'lodash/capitalize';

const BuyingOptionsTableColourCell: FunctionComponent<BuyingOptionsTableColourCellProps> = ({
    colour,
    image
}) => {
    return (
        <th class="buying-options__table-colour-cell">
            <span
                class={`d-flex align-items-center flex-column flex-sm-row ${
                    image === undefined ? 'w-100 justify-content-center' : ''
                }`}
            >
                {image !== undefined ? (
                    <img class="img-fluid mr-3" src={image.url} width="60" height="70" alt="" />
                ) : null}
                <span class="font-weight-bold">{capitalize(colour.replace('_', ' '))}</span>
            </span>
        </th>
    );
};

interface BuyingOptionsTableColourCellProps {
    colour: string;
    image: Image | undefined;
}

export default BuyingOptionsTableColourCell;
